import { DeveloperUserWithNotificationPreference } from 'server/lib/repositories/users-repository/types';
import { axiosRequestHelper, RequestHelperResult } from './endpoint-helpers';

export const updateUserInformation = (
    user: Partial<Omit<DeveloperUserWithNotificationPreference, 'id' | 'email'>>
): Promise<RequestHelperResult<DeveloperUserWithNotificationPreference>> =>
    axiosRequestHelper('PATCH', '/api/users/account', {
        data: user,
    });
